import React from "react";
import BaseComponent from "meta/features/base-component";
import Button from "meta/ui2/button";
import Alert from "meta/ui2/alert";
import Icon from "meta/ui2/icon";
import cn from "classnames";
import Cookie from "js-cookie";
import "meta/features/base-style";
import MutationObserver from "mutation-observer";

class LockScreen extends BaseComponent {
  constructor(props) {
    super(props);

    this._bind(
      "handleUnlock",
      "handleLogout",
      "lockscreenProtectionSetup",
      "clearProtection"
    );

    this.lockscreenIntervalId = null;
    this.lockScreenObserver = new MutationObserver((m) => {
      for (let element of m) {
        // check if child list operation on the parent
        if (
          element.type === "childList" &&
          element.target === this.lockScreen.parentNode
        ) {
          for (let removedNode of element.removedNodes) {
            if (removedNode === this.lockScreen) {
              // only reload when the node was removed
              window.document.body.style.display = "none";
              window.location.reload();

              // Most of the time this doesn't run, as removing the lockscreen element
              // from the tree causes its parent node to be null.
              // This means the condition above isn't even triggered and the code goes directly to the else clause.
            }
          }
        } else {
          window.document.body.style.display = "none";
          window.location.reload();
        }
      }
    });
  }

  componentDidUpdate(prevProps) {
    this.password.focus();

    if (this.props.locked) this.lockscreenProtectionSetup();
  }

  componentWillUpdate(nextProps) {
    if (nextProps.locked === false) this.clearProtection();
  }

  clearProtection() {
    clearInterval(this.lockscreenIntervalId);
    this.lockscreenIntervalId = null;
    this.lockScreenObserver.disconnect();
  }

  lockscreenProtectionSetup() {
    let ls = this.lockScreen;
    let lsStyleString = JSON.stringify(window.getComputedStyle(ls));
    this.lockScreenObserver.observe(ls, { attributes: true, childList: true });
    this.lockScreenObserver.observe(ls.parentNode, { childList: true });

    this.lockscreenIntervalId = setInterval(() => {
      let lsStyle = window.getComputedStyle(ls);
      let lockScreenChanged = lsStyleString !== JSON.stringify(lsStyle);

      if (lockScreenChanged) {
        if (this.props.locked) window.location.reload();
      }
    }, 1000);
  }

  handleUnlock() {
    let { unlockScreen } = this.props;

    unlockScreen(this.password.value);

    this.password.value = "";
  }

  handleLogout() {
    // reload root page cause full logout in pagehide event
    window.location.reload();
  }

  render() {
    let { locked, message, isLoading, appNameLongHtml } = this.props;
    let userName = Cookie.get("Login_UserOpId");
    const appNameHtml = () => ({
      __html: appNameLongHtml,
    });
    let _class = cn("lock-screen", {
      visible: locked,
    });

    let alert = message ? (
      <Alert type="danger">
        <Icon name="warning" /> {message}
      </Alert>
    ) : null;

    return (
      <div
        id="lock-screen"
        ref={(c) => (this.lockScreen = c)}
        className={_class}
      >
        <div>
          <span
            className="title"
            dangerouslySetInnerHTML={appNameHtml()}
          ></span>
        </div>
        <div>
          <span>Logged user: {userName}</span>
        </div>
        <div>
          <input
            type="password"
            className="form-control"
            onKeyPress={(e) => {
              if (e.key === "Enter") this.handleUnlock();
            }}
            ref={(c) => (this.password = c)}
          />
        </div>
        <div>
          {alert}
          <Button
            type="info"
            text="Unlock"
            isFixed
            width={200}
            isLoading={isLoading}
            onClick={this.handleUnlock}
          />
        </div>
        <div className="logout">
          <a href="#" onClick={this.handleLogout}>
            <Icon name="sign-out" /> Log Out
          </a>
        </div>
      </div>
    );
  }
}

LockScreen.propTypes = {};
LockScreen.defaultProps = {
  visible: false,
};

export default LockScreen;
